import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { I18nModule, provideDefaultConfig } from "@spartacus/core";
import { GenericLinkModule, NavigationModule } from "@spartacus/storefront";
import { KbFooterNavigationComponent } from "./kb-footer-navigation.component";
import { RouterModule } from "@angular/router";
import { KbNavigationUiModule } from "../kb-navigation-ui/kb-navigation-ui.module";

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    GenericLinkModule,
    I18nModule,
    NavigationModule,
    KbNavigationUiModule,
  ],
  providers: [
    provideDefaultConfig({
      cmsComponents: {
        FooterNavigationComponent: {
          component: KbFooterNavigationComponent,
        },
      },
    }),

  ],
  exports: [KbFooterNavigationComponent],
  declarations: [KbFooterNavigationComponent]
})
export class KbFooterNavigationModule {

}
